import { generateAssistantResponse } from './openai-assistant';
import { replaceSnippets } from './prompt-snippets';
import { toast } from './toast';

export { generateAssistantResponse } from './openai-assistant';

export async function generateAIRecommendations(prompt: string): Promise<string> {
  try {
    if (!prompt.trim()) {
      throw new Error('No prompt provided');
    }

    // Replace snippets in the prompt with actual data
    const processedPrompt = replaceSnippets(prompt);
    
    // Validate processed prompt
    if (!processedPrompt || processedPrompt.trim() === '') {
      throw new Error('Processed prompt is empty');
    }

    // Визначаємо мову з промпту або дефолтну
    let languageInstruction = '';
    if (processedPrompt.includes('Language: uk') || processedPrompt.includes('Ukrainian')) {
      languageInstruction = '🔴 ОБОВ\'ЯЗКОВО: Відповідай ТІЛЬКИ УКРАЇНСЬКОЮ МОВОЮ. Жодного російського чи англійського!\n\n';
    } else if (processedPrompt.includes('Language: ru') || processedPrompt.includes('Russian')) {
      languageInstruction = '🔴 ОБЯЗАТЕЛЬНО: Отвечай ТОЛЬКО НА РУССКОМ ЯЗЫКЕ. Никакого украинского или английского!\n\n';
    } else if (processedPrompt.includes('Language: en') || processedPrompt.includes('English')) {
      languageInstruction = '🔴 MANDATORY: Respond ONLY in ENGLISH. No Ukrainian or Russian!\n\n';
    }

    // Log the actual prompt being sent
    console.log('Processed prompt:', processedPrompt);
    console.log('Language instruction:', languageInstruction);

    // Use the assistant API with language instruction prepended
    const response = await generateAssistantResponse([
      {
        role: 'user',
        content: languageInstruction + processedPrompt
      }
    ]);

    return response;

  } catch (error) {
    console.error('Error generating AI recommendations:', error);
    toast.error(error instanceof Error ? error.message : 'Failed to generate AI recommendations');
    throw error;
  }
}